import { useIsMutating } from '@tanstack/react-query';

const useIsAddingSingleItemToCart = () => {
  const isAddingItemToCart =
    useIsMutating({
      mutationKey: ['adding-item-to-cart'],
    }) > 0;

  return isAddingItemToCart;
};

const useIsAddingMultipleItemsToCart = () => {
  const isAddingMultipleItemsToCart =
    useIsMutating({
      mutationKey: ['adding-items-to-cart'],
    }) > 0;

  return isAddingMultipleItemsToCart;
};

const useIsDeletingItemsFromCart = () => {
  const isDeletingItemsFromCart =
    useIsMutating({
      mutationKey: ['deleting-items-in-cart'],
    }) > 0;

  return isDeletingItemsFromCart;
};

const useIsEditingItemsInCart = () => {
  const isEditingItemsInCart =
    useIsMutating({
      mutationKey: ['editing-items-in-cart'],
    }) > 0;

  return isEditingItemsInCart;
};

export const useIsEditingCartContent = () => {
  const addingSingleItem = useIsAddingSingleItemToCart();
  const addingMultipleItems = useIsAddingMultipleItemsToCart();
  const deletingItems = useIsDeletingItemsFromCart();
  const editingItems = useIsEditingItemsInCart();

  return addingSingleItem || addingMultipleItems || deletingItems || editingItems;
};

export const useIsInitiatingPayment = () => {
  const isInitiatingPayment =
    useIsMutating({
      mutationKey: ['cart-pay'],
    }) > 0;

  return isInitiatingPayment;
};

export const useIsAddingToBill = () => {
  const isAddingToBill =
    useIsMutating({
      mutationKey: ['add-to-bill'],
    }) > 0;

  return isAddingToBill;
};

export const useCartIsClosing = () => {
  const isAddingToBill = useIsAddingToBill();
  const isInitiatingPayment = useIsInitiatingPayment();

  return isAddingToBill || isInitiatingPayment;
};

export const useCartIsBusy = () => {
  const cartIsClosing = useCartIsClosing();
  const isEditingItemsInCart = useIsEditingCartContent();

  return cartIsClosing || isEditingItemsInCart;
};
